import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaTwitter, FaLinkedinIn } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12 mt-16">
      <div className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-4 gap-8">
        {/* Clinic Info */}
        <div>
          <h3 className="text-xl font-semibold mb-3">Dr. Ashweeja Nagesh</h3>
          <p className="text-sm">
            Providing compassionate and expert mental health support tailored to your unique journey.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-lg font-semibold mb-3">Quick Links</h4>
          <ul className="text-sm space-y-2">
            <li><Link to="/" className="hover:underline">Home</Link></li>
            <li><Link to="/book-appointment" className="hover:underline">Book Appointment</Link></li>
            <li><Link to="/reviews" className="hover:underline">Reviews</Link></li>
            <li><Link to="/testimonials" className="hover:underline">Write a Testimonial</Link></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h4 className="text-lg font-semibold mb-3">Contact</h4>
          <p className="text-sm">Email: ashweejanagesh12@gmail.com</p>
          <p className="text-sm">Phone: +91 6284 594192</p>
          <div className="flex mt-3 space-x-4 text-xl text-gray-400">
            <a href="#" aria-label="Facebook" className="hover:text-white"><FaFacebookF /></a>
            <a href="#" aria-label="Instagram" className="hover:text-white"><FaInstagram /></a>
            <a href="#" aria-label="Twitter" className="hover:text-white"><FaTwitter /></a>
            <a href="#" aria-label="LinkedIn" className="hover:text-white"><FaLinkedinIn /></a>
          </div>
        </div>

        {/* Newsletter */}
        <div>
          <h4 className="text-lg font-semibold mb-3">Stay Connected</h4>
          <p className="text-sm mb-2">Get mental wellness tips in your inbox.</p>
          <form className="flex flex-col space-y-2">
            <input
              type="email"
              placeholder="Your email"
              className="px-3 py-2 rounded bg-white text-black text-sm focus:outline-none"
            />
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
            >
              Subscribe
            </button>
          </form>
        </div>
      </div>

      <div className="text-center text-xs mt-10 text-gray-500">
        © {new Date().getFullYear()} Dr. Ashweeja Nagesh. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
